<template>
  <div>
    <list
      row-key="LinkId"
      ref="list"
      unit="友情链接"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      :delete-func="api.delete"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="标题">
          <el-input size="mini" v-model="params.Title" placeholder="请输入标题" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Title" label="标题" width="350" />
        <el-table-column prop="Url" label="链接地址" />
        <el-table-column prop="Sort" label="排序" align="center" min-width="10" sortable="Title" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/website/link/link").default,
      params: {
        Title: ""
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  }
};
</script>